import Breadcrumbs from '@/components/Atoms/Breadcrumbs'
import { GlobalNotices } from '@/components/Atoms/GlobalNotices'
import Header from '@/components/Molecules/Header'
import MccsSidebar from '@/components/Molecules/MccsSidebar'
import { SidebarInset, SidebarProvider } from '@/components/ui/sidebar'
import { BreadcrumbsProvider } from '@/hooks/breadcrumbs'
import { GlobalNoticesProvider } from '@/hooks/global-notices'
import { useAuth } from '@/hooks/useAuth'
import { useEffect } from 'react'
import { Outlet, ScrollRestoration, useMatches } from 'react-router'
import { Footer } from '@/components/Molecules/Footer.tsx'

interface LayoutRouteProps {
  noSidebar?: true
}

export function Layout({ noSidebar }: LayoutRouteProps) {
  const { isAuthenticated } = useAuth()
  const matches = useMatches()
  const pageTitle = [...matches]
    .reverse()
    .find((m) => (m.handle as { title?: string } | null)?.title)?.handle as
    | { title?: string }
    | undefined

  useEffect(() => {
    document.title = pageTitle?.title ? `${pageTitle.title} | TxMCCS` : 'TxMCCS'
  }, [pageTitle])

  return (
    <GlobalNoticesProvider>
      <SidebarProvider>
        <BreadcrumbsProvider>
          <div className="flex flex-1 flex-col gap-2">
            <Header hideSidebar={noSidebar} />
            <div className="container mx-auto flex flex-1 gap-2 md:px-2">
              {isAuthenticated && !noSidebar && <MccsSidebar />}
              <SidebarInset className="max-w-svw min-w-0 gap-2 bg-transparent !shadow-none">
                {isAuthenticated && !noSidebar && <GlobalNotices />}
                {isAuthenticated && !noSidebar && <Breadcrumbs />}

                <ScrollRestoration />

                <main id="main-content">
                  <Outlet />
                </main>

                <Footer />
              </SidebarInset>
            </div>
          </div>
        </BreadcrumbsProvider>
      </SidebarProvider>
    </GlobalNoticesProvider>
  )
}

export default Layout
